import {useAuthStore} from "@/components/store/userAuth";

import {createRouter, createWebHistory} from "vue-router";
import {computed} from "vue";

const TheHome = () => import("@/views/TheHome.vue");
const TheLogin = () => import("@/views/TheLogin");
const TheRegistration = () => import("@/views/TheRegistration.vue");
const CurrentUserView = () => import("@/views/CurrentUserView.vue");
const UsersView = () => import("@/views/UsersView.vue");
const UserView = () => import("@/views/UserView.vue");
const AddressesView = () => import("@/views/AddressesView.vue");
const AddressView = () => import("@/views/AddressView.vue");
const ResourcesView = () => import("@/views/ResourcesView.vue");
const ResourceView = () => import("@/views/ResourceView.vue");
const ResourcesFilesView = () => import("@/views/ResourcesFilesView.vue");
const CatalogueView = () => import("@/views/CatalogueView.vue");
const ProductsView = () => import("@/views/ProductsView.vue");
const ProductView = () => import("@/views/ProductView.vue");
const CategoriesView = () => import("@/views/CategoriesView.vue");
const FeedCategoriesView = () => import("@/views/FeedCategoriesView.vue");
const FeedColorsView = () => import("@/views/FeedColorsView.vue");
const OrdersView = () => import("@/views/OrdersView.vue");
const CheckoutReview = () => import("@/views/CheckoutReview.vue");
const OrderConfirmation = () => import("@/views/OrderConfirmation.vue");
const NotFound = () => import("@/views/NotFound.vue");

const routes = [
    {
        path: "/fff",
        name: "Home",
        component: TheHome,
        meta: {requiresAuth: true},
    },
    {
        path: "/login",
        name: "Authorization",
        component: TheLogin,
    },
    {
        path: "/register",
        name: "Registration",
        component: TheRegistration,
    },
    {
        path: "/currentuser",
        name: "CurrentUserView",
        component: CurrentUserView,
        meta: {requiresAuth: true},
    },
    {
        path: "/userprofiles",
        name: "UsersView",
        component: UsersView,
        meta: {requiresAuth: true},
    },
    {
        path: "/userprofiles/:id",
        name: "UserView",
        component: UserView,
        meta: {requiresAuth: true},
    },
    {
        path: "/addresses",
        name: "AddressesView",
        component: AddressesView,
        meta: {requiresAuth: true},
    },
    {
        path: "/addresses/:id",
        name: "AddressView",
        component: AddressView,
        meta: {requiresAuth: true},
    },
    {
        path: "/resources",
        name: "ResourcesView",
        component: ResourcesView,
        meta: {requiresAuth: true},
    },
    {
        path: "/resources/:id",
        name: "ResourceView",
        component: ResourceView,
        meta: {requiresAuth: true},
    },
    {
        path: "/resourcesfiles",
        name: "ResourcesFilesView",
        component: ResourcesFilesView,
        meta: {requiresAuth: true},
    },
    {
        path: "/",
        name: "Catalogue",
        component: CatalogueView,
        meta: {requiresAuth: true},
    },
    {
        path: "/products",
        name: "ProductsView",
        component: ProductsView,
        meta: {requiresAuth: true},
    },
    {
        path: "/products/:id",
        name: "ProductView",
        component: ProductView,
        meta: {requiresAuth: true},
    },
    {
        path: "/categories",
        name: "CategoriesView",
        component: CategoriesView,
        meta: {requiresAuth: true},
    },
    {
        path: "/feedcategories",
        name: "FeedCategoriesView",
        component: FeedCategoriesView,
        meta: {requiresAuth: true},
    },
    {
        path: "/feedcolors",
        name: "FeedColorsView",
        component: FeedColorsView,
        meta: {requiresAuth: true},
    },
    {
        path: "/orders",
        name: "OrdersView",
        component: OrdersView,
        meta: {requiresAuth: true},
    },
    {
        path: "/checkout",
        name: "CheckoutReview",
        component: CheckoutReview,
        meta: {requiresAuth: true},
    },
    {
        path: "/orderconfirmation/:label",
        name: "OrderConfirmation",
        component: OrderConfirmation,
        meta: {requiresAuth: true},
    },
    {path: "/:notFound(.*)", component: NotFound},
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();
    const loggedIn = computed(() => authStore.isAuthenticated);

    if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn.value) {
        next({name: 'Authorization'})
    } else {
        next()
    }
})

export default router;
